import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

export default {

    async criaSubitens(subItensValores = {}){

        let subItens;

        try{

            //==================================================================//
            //========================= Cria Subitens ==========================//
            //==================================================================//

            subItens = await ERP.postMany(Schema.REVISAO_JOB_SUBITEMS, subItensValores);
            if(subItens.status != 200){
                throw subItens;
            }

            console.log(subItens);


        }catch(e){

            console.log(e);
            return subItens;

        }

        return subItens;

    },

}